import type { DsSelectOptions } from '~/components/common/DsSelect'
import { komaNumberTimeRange } from '~/models/komaToTime'

/**
 * コマ番号 (1-origin, 1〜48) を "HH:MM〜HH:MM" の時間帯ラベルに変換する。
 * コマ 48 は JEPX 慣習どおり "23:30〜24:00" (canonical `komaNumberTimeRange` に
 * 委譲。折り返さない)。
 */
export const slotTimeLabel = (index: number): string =>
  komaNumberTimeRange(index, '〜')

/**
 * スポット入札のコマ select の選択肢 (1〜48)。
 *
 * 表記は「28 (13:30〜14:00)」 = 全画面共通のコマ表記 (design `js/format-koma.js` の
 * compact 形。 時間前入札 [[IntradayBidCreateModal]] のコマ select と同じ形)。 項目名に
 * 「コマ」 が既出なので prefix は付けず、 番号もゼロ埋めしない (issue #5365 Des 裁定
 * 2026-08-18: ゼロ埋めは時間前と同時にしか変えない)。
 *
 * value は DS Select の都合で string。 form 側 (`timeCode: number`) へは
 * `FormSelect numeric` で戻す。
 */
export const SPOT_KOMA_OPTIONS: DsSelectOptions = Array.from(
  { length: 48 },
  (_, i) => i + 1,
).map((k) => ({ value: String(k), label: `${k} (${slotTimeLabel(k)})` }))
